import { Link } from 'react-router-dom';
import type { RewardsNavItem, RewardsSection } from '../rewardsPageTypes';
import { isRewardsNavActive } from '../rewardsPageUtils';

export const RewardsNav = (props: {
  items: readonly RewardsNavItem[];
  pathname: string;
  activeSection: RewardsSection;
}) => {
  const { items, pathname, activeSection } = props;

  return (
    <nav className='en-tabs' aria-label='Rewards sections'>
      {items.map((item) => {
        const isActive = isRewardsNavActive(item, pathname, activeSection);
        return (
          <Link
            key={item.id}
            to={item.href}
            className={`en-tab${isActive ? ' on' : ''}`}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

